var map = {
	"./action.png": "889f",
	"./admin.png": "bed2",
	"./assignments.png": "8ba9",
	"./calendar.png": "6c68",
	"./classroom.png": "c8cc",
	"./docs.png": "f710",
	"./drive.png": "5f3f",
	"./editors.png": "59a1",
	"./folder.png": "16cf",
	"./forms.png": "368b",
	"./gemini.png": "2317",
	"./gmail.png": "a680",
	"./jamboard.png": "74c0",
	"./keep.png": "087e",
	"./meet.png": "81cc",
	"./partners/adobe.png": "3b9a",
	"./partners/canva.png": "b637",
	"./sheets.png": "52a6",
	"./sites.png": "406a",
	"./slides.png": "473b",
	"./vids.png": "cb4d",
	"./voice.png": "bd44"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";